import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBook, FaUsers, FaGraduationCap, FaBriefcase, FaChartLine } from 'react-icons/fa';
import image1 from '../assets/image1.jpg';
import image2 from '../assets/images2.jpg';
import image3 from '../assets/images.jpg';
import image4 from '../assets/image5.jpg';
import SEO from './SEO';
import './Home.css';

const Home = () => {
  const images = [
    { src: image1, alt: 'Student studying' },
    { src: image2, alt: 'Group study' },
    { src: image3, alt: 'Online learning' },
    { src: image4, alt: 'Academic success' }
  ];

  return (
    <>
      <SEO 
        title="Student Helper - Your Academic Companion"
        description="Access study materials, ask questions, and collaborate with peers. Student Helper provides a comprehensive platform for students to enhance their learning experience."
        keywords="student helper, education platform, study materials, homework help, student collaboration"
      />
      <div className="home-container">
        <section className="hero-section">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-content"
          >
            <h1>Welcome to Student Helper</h1>
            <p>Your comprehensive platform for academic success</p>
          </motion.div>
        </section>

        <section className="features-section">
          <h2>Our Features</h2>
          <div className="features-grid">
            <motion.div
              className="feature-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <FaBook className="feature-icon" />
              <h3>Digital Library</h3>
              <p>Access a vast collection of study materials, textbooks, and research papers.</p>
            </motion.div>

            <motion.div 
              className="feature-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.1 }}
            >
              <FaUsers className="feature-icon" />
              <h3>Peer Learning</h3>
              <p>Join study groups and connect with fellow students for collaborative learning.</p>
            </motion.div>

            <motion.div 
              className="feature-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.2 }}
            >
              <FaGraduationCap className="feature-icon" />
              <h3>Expert Support</h3>
              <p>Get help from experienced professors and academic experts.</p>
            </motion.div>

            <motion.div 
              className="feature-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.3 }}
            >
              <FaBriefcase className="feature-icon" />
              <h3>Career Development</h3>
              <p>Explore job opportunities and career resources to kickstart your professional journey.</p>
            </motion.div>

            <motion.div 
              className="feature-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.4 }}
            >
              <FaChartLine className="feature-icon" />
              <h3>Gamification</h3>
              <p>Track your progress, earn achievements, and compete on the leaderboard.</p>
            </motion.div>
          </div>
        </section>

        <section className="gallery-section">
          <h2>Our Community</h2>
          <div className="gallery-grid">
            {images.map((image, index) => (
              <motion.div
                key={index}
                className="gallery-item"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <img src={image.src} alt={image.alt} className="gallery-image" />
              </motion.div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
